"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NumberInput = void 0;
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _lodash = require("lodash");
var _Button = require("../Button");
var _excluded = ["className", "disabled", "isValid", "onChange", "value"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
var NULL_DISPLAY_VALUE = '?';

// Matches any character that is not a digit \d
// and not a question mark
var INVALID_CHAR_REGEX = /[^\d?]/g;
var clampValue = function clampValue(value) {
  return (0, _lodash.clamp)(value, 0, 99);
};
var getColors = function getColors(_ref) {
  var isValid = _ref.isValid,
    disabled = _ref.disabled;
  if (disabled) {
    return 'bg-grey-10 text-grey-50';
  }
  if (!isValid) {
    return 'bg-alertred-10 text-alertred-60';
  }
  return 'bg-white text-black';
};
/**
 * `value` is limited to 99 since input
 * should not handle number larger than 2 digits.
 * Check in with design team if this poses a problem.
 */
var NumberInput = function NumberInput(_ref2) {
  var className = _ref2.className,
    disabled = _ref2.disabled,
    _ref2$isValid = _ref2.isValid,
    isValid = _ref2$isValid === void 0 ? true : _ref2$isValid,
    onChange = _ref2.onChange,
    value = _ref2.value,
    props = _objectWithoutProperties(_ref2, _excluded);
  // Display value inside text input should always be
  //  - an empty string
  //  - '?'
  //  - a valid number
  // Actual value returned by input should always be
  //  - an empty string
  //  - null
  //  - a valid number
  // Valid numbers should also be converted from strings to Numbers
  // for later deep equality checks.

  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    isFocused = _useState2[0],
    setIsFocused = _useState2[1];
  var handleChange = function handleChange(value) {
    if (value === '' || value === null) {
      onChange(value);
    } else {
      onChange(clampValue((0, _lodash.toNumber)(value)));
    }
  };
  var handleInputChange = function handleInputChange(e) {
    var newValue = e.target.value.replace(INVALID_CHAR_REGEX, '');
    if (newValue.includes(NULL_DISPLAY_VALUE)) {
      newValue = null;
    }
    handleChange(newValue);
  };
  var handleSubtract = function handleSubtract() {
    var newValue;
    if (value === NULL_DISPLAY_VALUE || value === '') {
      newValue = 0;
    } else {
      newValue = (0, _lodash.toNumber)(value) - 1;
    }
    handleChange(newValue);
  };
  var handleAdd = function handleAdd() {
    var newValue;
    if (value === NULL_DISPLAY_VALUE || value === '') {
      newValue = 1;
    } else {
      newValue = (0, _lodash.toNumber)(value) + 1;
    }
    handleChange(newValue);
  };
  var handleFocus = function handleFocus() {
    return setIsFocused(true);
  };
  var handleBlur = function handleBlur() {
    return setIsFocused(false);
  };
  var displayValue = (0, _lodash.isNil)(value) ? NULL_DISPLAY_VALUE : value;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('flex items-center', className)
  }, /*#__PURE__*/_react.default.createElement(_Button.CircleSecondaryButton, {
    icon: "subtract-heavy-16",
    disabled: disabled,
    onClick: handleSubtract,
    onFocus: handleFocus,
    onBlur: handleBlur
  }), /*#__PURE__*/_react.default.createElement("input", _extends({
    type: "text",
    disabled: disabled,
    autoComplete: "false",
    value: displayValue,
    className: (0, _classnames.default)('number-input-text', 'outline-none border-none rounded-[4px]', 'mx-[24px] py-[10px] px-0 w-[40px] h-[40px]', 'tw-label-medium text-center', {
      'number-input-text-disabled cursor-not-allowed': disabled
    }, {
      'number-input-text-focus': isFocused
    }, {
      'number-input-text-invalid': !isValid
    }, getColors({
      isValid: isValid,
      disabled: disabled
    })),
    onChange: handleInputChange,
    onFocus: handleFocus,
    onBlur: handleBlur
  }, props)), /*#__PURE__*/_react.default.createElement(_Button.CircleSecondaryButton, {
    icon: "add-heavy-16",
    disabled: disabled,
    onClick: handleAdd,
    onFocus: handleFocus,
    onBlur: handleBlur
  }));
};
exports.NumberInput = NumberInput;